/** API Frequency: HOUR | MATCH */
export const PAYMENT_FREQUENCY_OPTIONS = [
  { value: '', label: 'Select payment frequency' },
  { value: 'HOUR', label: 'Per hour' },
  { value: 'MATCH', label: 'Per match' },
] as const;
